import clsx from 'clsx';
import { useMemo, useState } from 'react';
import { PURCHASE_ORDER_DOCUMENT_TYPE } from '@received/pricing-model';
import { PDFPreview } from '../Sidebars/PDFPreviewSideBar/PDFPreview/PDFPreview';
import { Modal } from '../_uiComponents';
import { ContractTimeline, TopBar } from './components';
import styles from './PDFPreviewModal.module.scss';
import { BillingDocumentType, CoreBillingDocumentType } from '../../types/generalTypes';

interface PDFPreviewModalProps {
	isOpen: boolean;
	documentsList: Array<BillingDocumentType>;
	isContractTimelineOpen?: boolean;
	activationStartDate?: Date | null;
	activationEndDate?: Date | null;
	onClose: () => void;
	onDownload?: (document: BillingDocumentType) => void;
}

export const PDFPreviewModal = ({
	isOpen,
	documentsList,
	activationStartDate,
	activationEndDate,
	isContractTimelineOpen,
	onClose,
	onDownload,
}: PDFPreviewModalProps) => {
	const [activeIndex, setActiveIndex] = useState(0);

	// Filter out purchase orders for timeline (they don't have the required properties)
	const timelineDocuments = useMemo(
		() => documentsList.filter((doc): doc is CoreBillingDocumentType => doc.accountingEventType !== PURCHASE_ORDER_DOCUMENT_TYPE),
		[documentsList],
	);

	const closeModal = () => {
		setActiveIndex(0);
		onClose();
	};

	return (
		<Modal isOpen={isOpen} closeModal={closeModal} className={styles.container}>
			<TopBar
				document={documentsList[activeIndex]}
				onClose={closeModal}
				onDownload={onDownload ? () => onDownload(documentsList[activeIndex]) : undefined}
			/>
			<div className={clsx(styles.content, isContractTimelineOpen && styles.wideContent)}>
				<div className={clsx(styles.timelineContainer, isContractTimelineOpen && styles.visible)}>
					<ContractTimeline
						documentsList={timelineDocuments}
						activationStartDate={activationStartDate}
						activationEndDate={activationEndDate}
						activeDocumentIndex={activeIndex}
						setActiveDocumentIndex={setActiveIndex}
					/>
				</div>

				<div className={styles.pdfContainer}>
					<PDFPreview document={documentsList[activeIndex]} isOpen={isOpen} />
				</div>
			</div>

			{isOpen && <div className={styles.selectOverlay} onClick={closeModal}></div>}
		</Modal>
	);
};
